import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  NgZone,
  Output,
  Input,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { CoreService } from "../../services/coreService";
import {
  UntypedFormControl,
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  ValidationErrors,
  UntypedFormArray,
  AbstractControl,
  ReactiveFormsModule,
  FormsModule,
} from "@angular/forms";
import { EStackGroup } from "./utils/types/stack.types";
import { IValetSiteRequest } from "./utils/types/vallet.types";
import { minValue } from "./utils/validators/minLength.validator";
import { CommonModule } from "@angular/common";
import { GoogleMapsModule } from "@angular/google-maps";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatButtonModule } from "@angular/material/button";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { ControlMessageComponent } from "../../shared/components/control-message/control-message.component";
import { MatStepperModule } from "@angular/material/stepper";
import { StepperSelectionEvent } from "@angular/cdk/stepper";
import {
  stack_category as stack_category_const,
  currency_options as currency_options_const,
  currency_options_ar as currency_options_ar_const,
  daysof_week as daysof_week_const,
  parking_types as parking_types_const,
} from "./utils/types/stack.types";

declare var toastr: any;

type CurrencyCode = "KWD" | "BHD" | "SAR";

@Component({
  selector: "app-add-vallet-parking",
  templateUrl: "./add-vallet-parking.component.html",
  styleUrls: ["./add-vallet-parking.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatStepperModule,
    GoogleMapsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,

    ControlMessageComponent,
  ],
})
export class AddValletParkingComponent implements OnInit, OnChanges {
  allDaysForm!: UntypedFormGroup;
  beneficiaries: any[] | undefined;
  currentCategory: number | null = null;
  private countries: any;
  stack_category = stack_category_const;
  currency_options = currency_options_const;
  currency_options_ar = currency_options_ar_const;
  daysof_week = daysof_week_const;
  parking_types = parking_types_const;
  public parking_charge_types: any;
  public form: UntypedFormGroup;
  public zoom: any;
  public searchControl = new UntypedFormControl();
  public Latitude: any;
  public longitude: any;
  secondStepAttempt = false;
  thirdStepAttempt = false;
  @ViewChild("logo", { static: true })
  logoRef!: ElementRef;
  @ViewChild("search", { static: true })
  public searchElementRef1!: ElementRef;
  public draggable: boolean;
  private place: any;
  public Address: any;
  public stack: UntypedFormGroup | undefined;
  public beneficiary: UntypedFormGroup | undefined;
  public gate: UntypedFormGroup | undefined;
  public isSubmitted: any = false;
  @Input()
  data: any = null;
  @Input()
  logo: {
    base64: any;
    filename: any;
    content_type: any;
  } = {
    base64: null,
    filename: null,
    content_type: null,
  };
  @Output()
  submit = new EventEmitter<any>();
  patchValletStack: boolean = false;

  detailsStepForm!: UntypedFormGroup;
  locationStepForm!: UntypedFormGroup;
  paymentStepForm!: UntypedFormGroup;

  constructor(
    private coreService: CoreService,
    private ngZone: NgZone,
    private builder: UntypedFormBuilder,
  ) {
    this.initAllDaysForm();
    this.form = this.builder.group({
      title: ["Riyadh Park", Validators.required],
      title_ar: ["الرياض بارك", Validators.required],
      capacity: ["", [Validators.required, Validators.pattern(/^\d+$/)]],
      counter: ["", [Validators.required, Validators.pattern(/^\d+$/)]],
      area: ["Saudi Arabia", Validators.required],
      area_ar: ["Saudi Arabia", Validators.required],
      city: ["Riyadh"],
      city_ar: ["Saudi Arabia"],
      country: ["Saudi Arabia", Validators.required],
      country_ar: ["Saudi Arabia", Validators.required],
      Latitude: [
        "21.52920000000000000000",
        [Validators.required, Validators.pattern(/^-?(\d+\.?\d*|\.\d+)$/)],
      ],
      longitude: [
        "39.16110000000000000000",
        [Validators.required, Validators.pattern(/^-?(\d+\.?\d*|\.\d+)$/)],
      ],
      processing_fee: ["0.0000", [Validators.required]],
      valet_charge_stack: this.builder.array([], Validators.required),
      vat_percentage: ["0.0000", Validators.required],
      discount_percentage: ["0.0000", Validators.required],
      service_charge: ["0.0000", Validators.required],
      support_email: ["pass@getpass.me", Validators.required],
      currency: ["KWD", Validators.required],
      currency_ar: ["ك.د", Validators.required],
    });

    this.detailsStepForm = this.builder.group({
      title: this.form.controls.title,
      title_ar: this.form.controls.title_ar,
      capacity: this.form.controls.capacity,
      counter: this.form.controls.counter,
      processing_fee: this.form.controls.processing_fee,
      vat_percentage: this.form.controls.vat_percentage,
      discount_percentage: this.form.controls.discount_percentage,
      service_charge: this.form.controls.service_charge,
      support_email: this.form.controls.support_email,
      currency: this.form.controls.currency,
      currency_ar: this.form.controls.currency_ar,
    });

    this.locationStepForm = this.builder.group({
      area: this.form.controls.area,
      area_ar: this.form.controls.area_ar,
      city: this.form.controls.city,
      city_ar: this.form.controls.city_ar,
      country: this.form.controls.country,
      country_ar: this.form.controls.country_ar,
      Latitude: this.form.controls.Latitude,
      longitude: this.form.controls.longitude,
    });

    this.paymentStepForm = this.builder.group({
      valet_charge_stack: this.form.controls.valet_charge_stack,
    });

    // this.form.disable();
    this.stack = this.createFormGroup("stack");
    this.beneficiary = this.createFormGroup("beneficiary");
    this.gate = this.createFormGroup("gate");
    this.countries = [];
    this.parking_charge_types = [];
    this.draggable = true;
    this.place = {};
  }

  secondStepEnterAttempt() {
    this.secondStepAttempt = true;
    if (
      !(
        this.form.controls.title.valid &&
        this.form.controls.title_ar.valid &&
        this.form.controls.capacity.valid &&
        this.form.controls.counter.valid &&
        this.form.controls.processing_fee.valid &&
        this.form.controls.vat_percentage.valid &&
        this.form.controls.discount_percentage.valid &&
        this.form.controls.service_charge.valid &&
        this.form.controls.support_email.valid &&
        this.form.controls.currency.valid &&
        this.form.controls.currency_ar.valid
      )
    ) {
      toastr.error("", "Form is not valid.", { timeOut: 2000 });
    }
  }

  thirdStepEnter() {
    this.secondStepAttempt = false;
    const vallet_stack = this.data.valet_charge_stack;
    const is_all_days_of_week = vallet_stack[0].is_all_days_of_week;

    if (vallet_stack.length > 0 && is_all_days_of_week) {
      const data = vallet_stack[0];

      const controls = <UntypedFormArray>this.form.controls.valet_charge_stack;
      controls.controls[0].patchValue({
        charge_stack_category: data.charge_stack_category,
        grace_period: data.grace_period,
        from_min: data.from_min,
        to_min: data.to_min,
        day_of_week: data.day_of_week,
        flexible_hour_charge: data.flexible_hour_charge,
        additional_hour_charge: data.additional_hour_charge,
        per_hour_charge: data.per_hour_charge,
        per_visit_charge: data.per_visit_charge,
      });
    } else if (vallet_stack.length > 0 && !is_all_days_of_week) {
      const vallet_stack_form = <UntypedFormArray>(
        this.form.controls.valet_charge_stack
      );
      (vallet_stack_form as UntypedFormArray).controls.forEach((control, i) => {
        (control as UntypedFormGroup).patchValue({
          charge_stack_category: vallet_stack[i].charge_stack_category,
          grace_period: vallet_stack[i].grace_period,
          from_min: vallet_stack[i].from_min,
          to_min: vallet_stack[i].to_min,
          day_of_week: vallet_stack[i].day_of_week,
          flexible_hour_charge: vallet_stack[i].flexible_hour_charge,
          additional_hour_charge: vallet_stack[i].additional_hour_charge,
          per_hour_charge: vallet_stack[i].per_hour_charge,
          per_visit_charge: vallet_stack[i].per_visit_charge,
        });

        this.handleControlChanges(
          (vallet_stack_form as UntypedFormArray).value,
          i,
        );
      });
    } else {
    }
  }

  thirdStepEnterAttempt() {
    this.thirdStepAttempt = true;
    if (
      !(
        this.form.controls.area.valid &&
        this.form.controls.area_ar.valid &&
        this.form.controls.city.valid &&
        this.form.controls.city_ar.valid &&
        this.form.controls.country.valid &&
        this.form.controls.country_ar.valid &&
        this.form.controls.Latitude.valid &&
        this.form.controls.longitude.valid
      )
    ) {
      toastr.error("", "Form is not valid.", { timeOut: 2000 });
    }
  }

  onFileChange(event: { target: { files: string | any[] } }) {
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.form.patchValue({
          content_type: file.type,
          filename: file.name,
          base64: (reader.result as string).split(",")[1],
        });
      };
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data) {
      if (this.data != null) {
        this.form.patchValue({
          ...this.data,
        });

        const vallet_stack = this.data.valet_charge_stack;
        const is_all_days_of_week = vallet_stack[0].is_all_days_of_week;
        if (vallet_stack.length > 0 && is_all_days_of_week) {
          this.allDaysForm.patchValue({
            allDays: true,
          });
        } else if (vallet_stack.length > 0 && !is_all_days_of_week) {
          this.allDaysForm.patchValue({
            allDays: false,
          });
        } else {
          this.allDaysForm.patchValue({
            allDays: false,
          });
        }

        this.Latitude = +this.form.controls.Latitude.value;
        this.longitude = +this.form.controls.longitude.value;
      }
    }
  }

  async ngOnInit() {
    await this.getParkingPlaceRegConfig();
    await this.getBeneficiaries();
    this.searchControl = new UntypedFormControl();
    this.setCurrentPosition();

    if (typeof google !== "undefined" && google.maps && google.maps.places) {
      const autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef1.nativeElement,
        {
          types: ["address"],
        },
      );

      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();
          this.place = place;
          console.log(this.place);

          if (
            this.place.geometry === undefined ||
            this.place.geometry === null
          ) {
            return;
          }

          this.form.controls.Latitude.setValue(
            this.place.geometry.location.lat(),
          );
          this.form.controls.longitude.setValue(
            this.place.geometry.location.lng(),
          );
          this.form.controls.area.setValue(this.place.formatted_address);

          this.Latitude = this.place.geometry.location.lat();
          this.longitude = this.place.geometry.location.lng();
          this.zoom = 12;

          const arr = this.place.formatted_address.split(", ");
          this.form.controls.country.setValue(arr[arr.length - 1]);
        });
      });
    } else {
      setTimeout(() => {
        this.ngOnInit();
      }, 1000);
    }

    this.setCurrentPosition();
  }

  createFormGroup(source: string) {
    switch (source) {
      case "stack": {
        return this.builder.group({
          from_min: [null, [Validators.required, Validators.pattern(/^\d+$/)]],
          to_min: [null, [Validators.required, Validators.pattern(/^\d+$/)]],
          rate: [
            null,
            [Validators.required, Validators.pattern(/^(\d+\.?\d*|\.\d+)$/)],
          ],
          rate_amount: [null],
          label_en: [null],
          label_ar: [null],
        });
      }
      case "beneficiary": {
        return this.builder.group({
          beneficiary_id: [null],
          beneficiary: [null, [Validators.required]],
          amount_type: [null, [Validators.required]],
          amount_calc: [null, [Validators.required]],
          value: [
            null,
            [Validators.required, Validators.pattern(/^(\d+\.?\d*|\.\d+)$/)],
          ],
        });
      }
    }
  }

  async getBeneficiaries() {
    try {
      this.beneficiaries = await this.coreService
        .GetBeneficiaries()
        .then((response) => response.data);
    } catch (error) {
      console.log(error);
    }
  }

  getParkingPlaceRegConfig() {
    this.coreService.GetParkingPlaceRegConfig().then((result) => {
      let countries = result.countries;
      let parking_charge_types = result.parking_charge_types;
      //we got all the data as an object so converting that object to key value pairs.
      for (let key in countries) {
        if (countries.hasOwnProperty(key)) {
          let temp1 = { code: key, name: countries[key] };
          this.countries.push(temp1);
        }
      }
      for (let key in parking_charge_types) {
        if (parking_charge_types.hasOwnProperty(key)) {
          let temp2 = { key: key, value: parking_charge_types[key] };
          this.parking_charge_types.push(temp2);
        }
      }
    });
  }

  setCurrentPosition() {
    this.ngZone.runOutsideAngular(() => {
      this.Latitude = 25.249062;
      this.longitude = 55.295110499999964;
      this.zoom = 2;
    });
  }

  markerDragEndAddress(event: google.maps.MapMouseEvent) {
    const latLng = event.latLng?.toJSON();

    if (!latLng) return;

    this.form.controls.Latitude.setValue(latLng.lat);
    this.form.controls.longitude.setValue(latLng.lng);
  }

  onMapClick(event: google.maps.MapMouseEvent) {
    const coords = event.latLng?.toJSON();
    if (!coords) return;

    this.form.controls.Latitude.setValue(coords.lat);
    this.form.controls.longitude.setValue(coords.lng);

    this.Latitude = coords.lat;
    this.longitude = coords.lng;
  }

  saveFormGroup(source: string) {
    switch (source) {
      case "stack": {
        const tempForm = <UntypedFormArray>(
          this.form.controls.valet_charge_stack
        );
        if (this.stack) {
          this.stack.controls.rate_amount.setValue(
            this.stack.controls.rate.value * 1000,
          );
        }
        tempForm.push(this.stack);
        this.stack = this.createFormGroup("stack");
        break;
      }

      case "beneficiary": {
        break;
      }
    }
  }

  deleteFormGroup(index: number, source: string) {
    if (confirm(`Are you sure you want to delete ${source}?`)) {
      switch (source) {
        case "stack": {
          const tempForm = <UntypedFormArray>(
            this.form.controls.valet_charge_stack
          );
          tempForm.removeAt(index);
          break;
        }
        case "beneficiary": {
          break;
        }
      }
    }
  }

  saveParkingPlace() {
    if (this.form.invalid) {
       this.logInvalidControls(this.form);
      toastr.error("", "Form is invalid.", {
        timeOut: 2000,
      });
      console.log(this.form);
      return;
    }

    const a: IValetSiteRequest | null = null;
    let formValue = this.form.value;
    let raw_value = this.form.getRawValue().valet_charge_stack;

    formValue.valet_charge_stack = formValue.valet_charge_stack.map(
      (x: any, i: string | number) => ({
        ...x,
        day_of_week: raw_value[i].day_of_week,
      }),
    );

    let vallet_stack = formValue.valet_charge_stack;

    if (vallet_stack.length > 0) {
      let mappedValletStack = vallet_stack.map((x: any) => ({
        ...x,
        is_all_days_of_week: this.allDaysForm.value.allDays,
      }));
      formValue.valet_charge_stack = mappedValletStack;
      vallet_stack = mappedValletStack;
    }
    if (this.getFormValidationErrors()) {
      formValue.Latitude = this.truncate(this.form.controls.Latitude.value, 6);

      formValue.longitude = this.truncate(
        this.form.controls.longitude.value,
        6,
      );

      formValue.valet_site_type = "valet";
      formValue.isActive = true;
      this.submit.emit(formValue);
    }
  }

  getFormValidationErrors() {
    let valid = true;
    Object.keys(this.form.controls).forEach((key) => {
      const controlErrors: ValidationErrors | null = this.form.get(key)!.errors;
      if (controlErrors != null) {
        valid = false;
        Object.keys(controlErrors).forEach((keyError) => {
          console.log(
            "Key control: " + key + ", keyError: " + keyError + ", err value: ",
            controlErrors[keyError],
          );
        });
      }
    });
    return valid;
  }

  truncate(num: number, places: number) {
    return Math.trunc(num * Math.pow(10, places)) / Math.pow(10, places);
  }

  getTitle(id: any) {
    return this.beneficiaries!.find((element) => element.id == id).title;
  }

  onAreaChange(val: { target: { value: any } }) {
    this.form.controls.area.setValue(val.target.value);
  }

  onCurrencyChange(englishCurrency: string) {
    const currencyMap: Record<CurrencyCode, string> = {
      KWD: "دينار كويتي",
      BHD: "دينار بحريني",
      SAR: "ريال سعودي",
    };

    if (currencyMap[englishCurrency as CurrencyCode]) {
      this.form.controls.currency_ar.setValue(
        currencyMap[englishCurrency as CurrencyCode],
      );
    }
  }

  createStackControl(type: EStackGroup) {
    switch (type) {
      case EStackGroup.AllControls:
        return this.builder.group({
          charge_stack_category: ["", Validators.required],
          grace_period: ["", [Validators.required, minValue(0)]],
          from_min: ["", [Validators.required, minValue(0)]],
          to_min: ["", [Validators.required, minValue(0)]],
          flexible_hour_charge: ["", [Validators.required, minValue(0)]],
          additional_hour_charge: ["", [Validators.required, minValue(0)]],
          day_of_week: ["", Validators.required],
          per_hour_charge: ["", [Validators.required, minValue(0)]],
          per_visit_charge: ["", [Validators.required, minValue(0)]],
        });
      default:
        break;
    }
  }

  addValletChargeStack() {}

  get valet_charge_stack() {
    return <UntypedFormArray>this.form.controls["valet_charge_stack"];
  }

  addValletListner(): void {
    this.form.controls.valet_charge_stack.valueChanges.subscribe({
      next: (controls) => {
        if (this.allDaysForm.value.allDays) {
          this.handleControlChanges(controls, 0);
        } else {
        }
      },
    });
  }

  categoryChanged(i: number) {
    this.currentCategory = i;
    this.handleControlChanges(
      <UntypedFormArray>this.form.controls.valet_charge_stack.value,
      i,
    );
  }

  handleControlChanges(
    controls: string | any[] | UntypedFormArray,
    index: number,
  ) {
    let valetstack = <UntypedFormArray>this.form.controls.valet_charge_stack;
    if (!valetstack.controls[index]) return;

    // Helper function to safely get control or return null
    const getControl = (controlName: string) => {
      return valetstack.controls[index].get(controlName);
    };

    if (
      controls.length > 0 &&
      (controls as any[])[index].charge_stack_category != ""
    ) {
      if (
        (controls as any[])[index].charge_stack_category ==
        this.stack_category[0].id
      ) {
        // Enable specific controls
        const categoryControl = getControl("charge_stack_category");
        const gracePeriodControl = getControl("grace_period");
        const perVisitControl = getControl("per_visit_charge");

        if (categoryControl) this.enable(categoryControl);
        if (gracePeriodControl) this.enable(gracePeriodControl);
        if (perVisitControl) this.enable(perVisitControl);

        // Disable specific controls
        const fromMinControl = getControl("from_min");
        const toMinControl = getControl("to_min");
        const flexibleHourControl = getControl("flexible_hour_charge");
        const additionalHourControl = getControl("additional_hour_charge");
        const perHourControl = getControl("per_hour_charge");

        if (fromMinControl) this.disable(fromMinControl);
        if (toMinControl) this.disable(toMinControl);
        if (flexibleHourControl) this.disable(flexibleHourControl);
        if (additionalHourControl) this.disable(additionalHourControl);
        if (perHourControl) this.disable(perHourControl);
      } else if (
        (controls as any[])[index].charge_stack_category ==
        this.stack_category[1].id
      ) {
        // Enable specific controls
        const categoryControl = getControl("charge_stack_category");
        const gracePeriodControl = getControl("grace_period");
        const perHourControl = getControl("per_hour_charge");

        if (categoryControl) this.enable(categoryControl);
        if (gracePeriodControl) this.enable(gracePeriodControl);
        if (perHourControl) this.enable(perHourControl);

        // Disable specific controls
        const fromMinControl = getControl("from_min");
        const toMinControl = getControl("to_min");
        const flexibleHourControl = getControl("flexible_hour_charge");
        const additionalHourControl = getControl("additional_hour_charge");
        const perVisitControl = getControl("per_visit_charge");

        if (fromMinControl) this.disable(fromMinControl);
        if (toMinControl) this.disable(toMinControl);
        if (flexibleHourControl) this.disable(flexibleHourControl);
        if (additionalHourControl) this.disable(additionalHourControl);
        if (perVisitControl) this.disable(perVisitControl);
      } else if (
        (controls as any[])[index].charge_stack_category ==
        this.stack_category[2].id
      ) {
        // Enable specific controls
        const categoryControl = getControl("charge_stack_category");
        const gracePeriodControl = getControl("grace_period");
        const fromMinControl = getControl("from_min");
        const toMinControl = getControl("to_min");
        const flexibleHourControl = getControl("flexible_hour_charge");
        const additionalHourControl = getControl("additional_hour_charge");

        if (categoryControl) this.enable(categoryControl);
        if (gracePeriodControl) this.enable(gracePeriodControl);
        if (fromMinControl) this.enable(fromMinControl);
        if (toMinControl) this.enable(toMinControl);
        if (flexibleHourControl) this.enable(flexibleHourControl);
        if (additionalHourControl) this.enable(additionalHourControl);

        // Disable specific controls
        const perVisitControl = getControl("per_visit_charge");
        const perHourControl = getControl("per_hour_charge");

        if (perVisitControl) this.disable(perVisitControl);
        if (perHourControl) this.disable(perHourControl);
      }
    }
  }

  initAllDaysForm(): void {
    this.allDaysForm = this.builder.group({
      allDays: [false],
    });

    this.allDaysForm.valueChanges.subscribe({
      next: (formData) => {
        let valetstack = <UntypedFormArray>(
          this.form.controls.valet_charge_stack
        );
        while (valetstack.length > 0) {
          valetstack.removeAt(0);
        }
        this.isSubmitted = false;
        if (!formData.allDays) {
          Array.of(0, 1, 2, 3, 4, 5, 6).forEach((i) => {
            const control = this.createStackControl(EStackGroup.AllControls);
            control!.patchValue({
              day_of_week: this.daysof_week[i].id,
            });

            control!.disabled ? "" : control!.disable();
            control!.controls.charge_stack_category.enabled
              ? ""
              : control!.controls.charge_stack_category.enable();
            valetstack.push(control);
          });
          this.addValletListner();

          return;
        }

        const control = this.createStackControl(EStackGroup.AllControls);
        if (control) {
          control.disabled ? "" : control.disable();
          control.controls.charge_stack_category.enabled
            ? ""
            : control.controls.charge_stack_category.enable();
        }
        valetstack.push(control);

        this.addValletListner();
      },
    });
  }

  enable(control: AbstractControl) {
    control.enabled ? "" : control.enable();
  }

  disable(control: AbstractControl) {
    control.disabled ? "" : control.disable();
  }

  onStepChange(event: StepperSelectionEvent): void {
    if (event.selectedIndex === 2) {
      this.thirdStepEnter();
    }
  }

  private markGroupTouched(group: UntypedFormGroup): void {
    Object.values(group.controls).forEach((control) => {
      control.markAsTouched();

      if (control instanceof UntypedFormGroup) {
        this.markGroupTouched(control);
      }
    });
  }

  validateDetailsStep(): boolean {
    this.markGroupTouched(this.detailsStepForm);
    this.detailsStepForm.updateValueAndValidity();

    if (this.detailsStepForm.invalid) {
      toastr.error("", "Form is not valid.", { timeOut: 2000 });
      return false;
    }

    return true;
  }

  validateLocationStep(): void {
    this.markGroupTouched(this.locationStepForm);

    // Force update validity (important in your form setup)
    this.locationStepForm.updateValueAndValidity();

    if (this.locationStepForm.invalid) {
      console.log("Invalid location form controls:");

      Object.keys(this.locationStepForm.controls).forEach((key) => {
        const control = this.locationStepForm.get(key);

        if (control?.invalid) {
          console.log(`- ${key}:`, {
            value: control.value,
            errors: control.errors,
          });
        }
      });

      toastr.error("", "Location form is not valid.", { timeOut: 2000 });
    }
  }

  private logInvalidControls(
    control: AbstractControl,
    path: string = "",
  ): void {
    if (control instanceof UntypedFormGroup) {
      Object.keys(control.controls).forEach((key) => {
        const child = control.get(key);
        if (!child) return;

        const currentPath = path ? `${path}.${key}` : key;

        if (child.invalid) {
          console.log(`❌ ${currentPath}`, {
            value: child.value,
            errors: child.errors,
          });
        }

        this.logInvalidControls(child, currentPath);
      });
    } else if (control instanceof UntypedFormArray) {
      control.controls.forEach((child, index) => {
        const currentPath = `${path}[${index}]`;

        if (child.invalid) {
          console.log(`❌ ${currentPath}`, {
            value: child.value,
            errors: child.errors,
          });
        }

        this.logInvalidControls(child, currentPath);
      });
    }
  }
}
